import { useEffect, useState, type ReactNode } from 'react'
import { useRouterState } from '@tanstack/react-router'
import { SidebarProvider } from './ui/sidebar'

/** Site gets temporary rail state; other routes retain the saved user preference. */
export function RouteSidebarProvider({ children }: { children: ReactNode }) {
  const pathname = useRouterState({
    select: (state) => state.location.pathname,
  })
  const isSite = pathname === '/site' || pathname.startsWith('/site/')
  const [open, setOpen] = useState(() =>
    typeof document === 'undefined'
      ? true
      : !document.cookie.split('; ').includes('sidebar_state=false'),
  )
  const [siteOpen, setSiteOpen] = useState(false)
  useEffect(() => {
    if (!isSite) setSiteOpen(false)
  }, [isSite])
  return (
    <SidebarProvider
      open={isSite ? siteOpen : open}
      onOpenChange={isSite ? setSiteOpen : setOpen}
      persistState={!isSite}
    >
      {children}
    </SidebarProvider>
  )
}
